import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import styles from "../../../../../../src/pages/schoolCockpit/master/academicConfiguration/Academiclist.module.css";
import { getStatusBadge } from "./lessonPlanApprovalColumns";

function LessonPlanApprovalHistoryPanel({ row }) {
  const { translations } = useSelector((state) => state.language);
  const history = row?.original?.history || [];

  if (!history.length) {
    return (
      <div className={styles.accordionEmpty}>
        {translations?.labels?.noHistoryFound || "No history found"}
      </div>
    );
  }

  return (
    <div className={styles.accordionPanel}>
      <table className={styles.accordionTable}>
        <thead>
          <tr>
            <th>{translations?.labels?.userName || "User Name"}</th>
            <th>{translations?.labels?.topic || "Topic"}</th>
            <th>{translations?.labels?.subTopic || "Sub Topic"}</th>
            <th>{translations?.labels?.updatedStatus || "Updated Status"}</th>
            <th>{translations?.labels?.updatedOn || "Updated On"}</th>
            <th>{translations?.labels?.comments || "Comments"}</th>
          </tr>
        </thead>
   
        <tbody>
          {history.map((h, idx) => (
            <tr key={idx}>
              <td>{h.user_name  || "-"}</td>
              <td>{h.topic || "-"}</td>
              <td>{h.sub_topic || "-"}</td>
              <td>{getStatusBadge(h.status_text || h.status)}</td>
              <td>
                {h.updated_on
                  ? moment(h.updated_on).format("DD/MM/YYYY [at] hh : mm a")
                  : "-"}
              </td>
              <td>{h.comments || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LessonPlanApprovalHistoryPanel;